import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
export const constantRoutes = [{
	path: "/",
	name: "Login",
	meta: {
		title: "登录",
	},
	component: () => import("@/views/login/login"),
}, {
	path: "/register",
	name: "Register",
	meta: {
		title: "注册",
	},
	component: () => import("@/views/login/register"),
}, {
	path: "/forget",
	name: "Forget",
	meta: {
		title: "忘记密码",
	},
	component: () => import("@/views/login/forget"),
}, {
	path: "/viewVideo",
	name: "ViewVideo",
	meta: {
		title: "视频预览",
	},
	component: () => import("@/views/view-video"),
}, {
	path: "/noticeDetail",
	name: "NoticeDetail",
	meta: {
		title: "动态详情",
	},
	component: () => import("@/views/notice-detail"),
}, {
	path: "/index",
	name: "Index",
	meta: {
		title: "首页",
		expertTitle: "参赛作品评审"
	},
	component: () => import("@/views/index"),
}, {
	path: "/detail",
	name: "Detail",
	meta: {
		title: "参赛作品详情",
	},
	component: () => import("@/views/detail"),
}, {
	path: "/history",
	name: "History",
	meta: {
		title: "提交材料记录",
	},
	component: () => import("@/views/history"),
}, {
	path: "/report",
	name: "Report",
	meta: {
		title: "评审列表",
	},
	component: () => import("@/views/report"),
}, {
	path: "/process-advancement",
	name: "ProcessAdvancement",
	meta: {
		title: "项目过程管理",
	},
	component: () => import("@/views/process-advancement"),
}, {
	path: "/draw-lots",
	name: "DrawLots",
	meta: {
		title: "省赛抽签",
	},
	component: () => import("@/views/draw-lots"),
}];


const router = new VueRouter({
	scrollBehavior: () => ({
		y: 0,
	}),
	routes: constantRoutes,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject)
		return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch((err) => err);
};

export function resetRouter() {
	router.matcher = new VueRouter({
		scrollBehavior: () => ({
			y: 0,
		}),
		routes: constantRoutes,
	}).matcher;
}

export default router;